import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: '#e8f4fd',
            color: '#0d3c61',
            borderWidth: 8,
            borderColor: '#0d3c61',
        },
        action: {
            width: 160,
            minHeight: 0,
            maxWidth: '100%',
            borderColor: '#0d3c61',
            [theme.breakpoints.down('xs')]: {
                width: 120,
            },
        },
        actionTitle: {
            backgroundColor: '#0d3c61',
        },
        title: {
            color: '#0d3c61',
        },
        photosTitle: {
            display: 'inline-flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
        },
        actionsContainer: {
            'display': 'inline-flex',
            'justifyContent': 'space-between',
            'alignItems': 'center',
            '& > $action': {
                'margin': theme.spacing(0, 1),
                '&:first-child': {
                    marginLeft: 0,
                },
                '&:last-child': {
                    marginRight: 0,
                },
            },
        },
        sectionTitle: {
            fontSize: '1.2rem',
            padding: theme.spacing(2),
            textAlign: 'center',
        },
        sectionTitleContainer: {
            height: '6rem',
            backgroundColor: '#F0F0F0',
            padding: theme.spacing(2),
            borderBottomWidth: 1,
            borderBottomColor: theme.palette.border.main,
            borderBottomStyle: 'solid',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        customizationContainer: {
            marginLeft: 0,
        },
        underline: {
            textDecoration: 'underline',
        },
    }),
)
